import { render, staticRenderFns } from "./templateModal.vue?vue&type=template&id=c1784826&scoped=true"
import script from "./templateModal.vue?vue&type=script&lang=js"
export * from "./templateModal.vue?vue&type=script&lang=js"
import style0 from "./templateModal.vue?vue&type=style&index=0&id=c1784826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1784826",
  null
  
)

export default component.exports